import { Fragment } from "react";
import withUrlOptions from "../common/hoc/withUrlOptions";
import { BUCKEYE_BOT, INTENTS } from "../util/constants";
import Bot, { IntentsProvider, ThemeProvider } from "../util/chatbot";
import { Interactions } from "@aws-amplify/interactions";

const Chatbot = (props = {}) => {
  const { component = 'div', darkMode, fullView, className = '', ...rest } = {
    headingStart: 1,
    ...props
  };

  return (
    <Fragment>
      <header className={fullView ? "sr-only" : "App-header"}>
        <h1 className="header-start">
          Buckeye Chat
        </h1>
      </header>
      <ThemeProvider theme={{ type: darkMode ? "dark" : "light" }}>
        <IntentsProvider
          intents={{
            welcome: INTENTS.WELCOME,
            positive: INTENTS.POSITIVE,
            negative: INTENTS.NEGATIVE,
            help: INTENTS.HELP,
          }}
        >
          <Bot
            className={className}
            component={component}
            botname={BUCKEYE_BOT}
            Interactions={Interactions}
            {...rest}
          />
        </IntentsProvider>
      </ThemeProvider>
    </Fragment>
  );
};


export default withUrlOptions(Chatbot);
